export default __webpack_public_path__ + "static/media/logo.c044bc5c.svg";